import { ICON__check } from '@/assets/icons_fa';
import { UI_PRIMITIVE__button } from '@/components/ui/UI_PRIMITIVE__button';
import { UI_PRIMITIVE__input } from '@/components/ui/UI_PRIMITIVE__input';
import { ENUM__html_ref_stub } from '@/enums/ENUM__html_ref_stub';
import { Key } from '@/enums/key';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_effect } from '@/hooks/_base/use_effect';
import { use_ref_with_fallback } from '@/hooks/_base/use_ref_with_fallback';
import { remote_search_update } from '@/state/search/remote_search_update';
import { DTOSearchSettings } from '@shared/dto/search/dto_search_settings';
import React, { useState } from 'react';

interface Props {
  item: DTOSearchSettings;
  setIsShowInputUpdateName: (value: boolean) => void;
}

export function SInputSearchItemName({ item, setIsShowInputUpdateName }: Props) {
  const dispatch = use_dispatch();
  const [inputValue, setInputValue] = useState(item.name);

  const ref_input = use_ref_with_fallback(ENUM__html_ref_stub.INPUT);
  const ref_button = use_ref_with_fallback(ENUM__html_ref_stub.BUTTON);

  /*
   * EFFECTS
   */

  use_effect(() => ref_input.current.select(), []);

  /*
   * EVENTS
   */
  function onBlur(e: React.FocusEvent<HTMLInputElement> | null = null) {
    if (e?.relatedTarget == ref_button.current) return;

    e?.stopPropagation();

    setIsShowInputUpdateName(false);
  }

  async function onKeyDown(e: React.KeyboardEvent<HTMLInputElement>) {
    if (e.key === Key.Enter) {
      await onEnterPressed();
    }

    if (e.key === Key.Escape) {
      onBlur();
    }
  }

  async function onEnterPressed() {
    let nameNew = inputValue.trim();

    if (item.name == nameNew || nameNew.is_blank()) return onBlur();

    setInputValue(nameNew);

    let item_new = item.clone({ name: nameNew });

    await dispatch(remote_search_update(item_new));

    onBlur();
  }

  /*
   * HTML
   */

  return (
    <>
      <div className="list-item-wrapper relative px-0 ">
        <UI_PRIMITIVE__input
          ref={ref_input}
          value={inputValue}
          maxLength={30}
          {...{ onBlur, onKeyDown }}
          onChange={e => setInputValue(e.target.value)}
          className="bg-component-item-selected w-full rounded-lg outline-none border-none px-3 max-h-9 focus:h-[2.375rem] md:text-base"
          autoFocus
        />
        <UI_PRIMITIVE__button ref={ref_button} className="w-7 absolute top-2 right-1" size="square-5" variant="no-border-on-component" onClick={onEnterPressed}>
          <ICON__check className="!size-3" />
        </UI_PRIMITIVE__button>
      </div>
    </>
  );
}
